import React from 'react';
import Location from 'components/dynamic-form/custom-elements/location';

export default ({ input, qaId }) => <Location input={input} qaId={qaId} component={Location} />;
